import { TrackableList } from 'types/trackables';

import { TRACKABLE_OBJECT_TYPE_LABELS } from '../utils';

import { Drawer, DrawerProps } from 'components/Drawer/DrawerDeprecated';
import { Text } from 'components/Text/Text';

import { AddTrackableItemForm } from './AddTrackableItemForm';

export type AddTrackableItemDialogProps = DrawerProps & {
  trackableList: TrackableList;
  onSuccess?: (createdItemId: string) => void;
};

export function AddTrackableItemDialog({
  trackableList,
  open,
  onClose,
  onSuccess,
}: AddTrackableItemDialogProps) {
  const itemType =
    TRACKABLE_OBJECT_TYPE_LABELS[trackableList.object_type].toLowerCase();
  const title = `Add ${itemType}`;

  return (
    <Drawer title={title} open={open} onClose={onClose}>
      <Text type="paragraph">
        Add a {itemType} to the "{trackableList.name}" watchlist for tracking in
        video streams.
      </Text>

      <AddTrackableItemForm
        trackableListId={trackableList.id}
        objectType={trackableList.object_type}
        onSuccess={(createdItemId) => {
          onClose?.();
          onSuccess?.(createdItemId);
        }}
      />
    </Drawer>
  );
}
